import { render } from "./Staff.vue?vue&type=template&id=49f7d1a5&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=49f7d1a5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ThinleyNorbu\\source\\repos\\1185_BF_Module_0\\vueOktaVersion\\custom-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f7d1a5"]])

export default __exports__